import React from 'react';
import '../App.css';
import WelComeLayer from '../components/WelcomeLayer'
import 'bootstrap/dist/css/bootstrap.min.css';
import InscriptionForm from "../components/InscriptionForm";
import CiberAlerts, {GLOBALS, MESSAGES} from "../util/Messages";
import {ColorSchemeQuery} from "../apollo/queries/ColorSchemeQuery";
import {Query} from "react-apollo";
import Spinner from "react-bootstrap/Spinner";
import {LightenDarkenColor} from "lighten-darken-color";

export default class InscriptionApp extends React.Component {

  setInstitution(institution) {
    sessionStorage.setItem("institution", JSON.stringify(institution));
  }

  render() {
    return (
      <>
        <Query query={ColorSchemeQuery} fetchPolicy={"network-only"}
               variables={{institutionId: this.getInstitutionId()}}
               onError={(error) => {
                 console.log(error)
               }}
        >
          {({loading, error, data}) => {
            if (loading) {
              return (
                <Spinner animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner>);
            } else if (error) {
              return <><WelComeLayer logo={this.getLogo()} message={MESSAGES.WELCOME_MESSAGE}
                                     background={GLOBALS.defaultColor}/>
                <div className="card card-signin my-5 col-sm-6 border-left-0">
                  <div className="card-body">
                    <h1 className="card-title text-center">Inscripción a Cibercolegios</h1>
                    <CiberAlerts error="CIB-GEN-0027"/>
                  </div>
                </div>
              </>
            } else {
              console.log(data);
              this.setInstitution(data);
              return <>
                {data.colorScheme ?
                  <style type="text/css">
                    {`
                    html {
                      font-family: ${data.colorScheme.fontFamily} !important;
                    }
                    body {
                      font-family: ${data.colorScheme.fontFamily} !important;
                    }
                    .institution-font{
                      color: ${data.colorScheme.fontColorSupMenu} !important;
                    }
                     .btn-primary {
                        background-color: ${LightenDarkenColor(data.colorScheme.menuColor, 50)};
                        color: ${data.colorScheme.fontColorSupMenu} !important;
                        border-color: ${LightenDarkenColor(data.colorScheme.menuColor, 50)} !important;
                    }
                    .btn-primary, .btn-primary:hover, .btn-primary:active, .btn-primary:visited {
                        background-color: ${data.colorScheme.menuColor} !important;
                        color: ${data.colorScheme.fontColorSupMenu} !important;
                        border-color: ${data.colorScheme.menuColor} !important;
                    }
                    
                  `}
                  </style> : null}

                <WelComeLayer logo={this.getLogo()} message={MESSAGES.WELCOME_MESSAGE}
                              background={data.colorScheme ? data.colorScheme.menuColor : GLOBALS.defaultColor}
                              footer={GLOBALS.footerImage}
                              mail={data.colorScheme ? data.colorScheme.adminEmail : GLOBALS.defaultEmail}

                />
                <InscriptionForm/>
              </>
            }

          }}

        </Query>
      </>
    );
  }


  getLogo() {
    const institutionId = this.getInstitutionId();
    if (process.env.PUBLIC_URL.indexOf('appsprod') >= 0) {
      return `https://www.cibercolegios.com/pls/ciber/barras_menu.ver_logo?p_id_institucion=${institutionId}`
    } else {
      return `https://pruebas.cibercolegios.com/pls/ciber/barras_menu.ver_logo?p_id_institucion=${institutionId}`
    }
  }

  getInstitutionId() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get('institutionId');
  }

}
